import { Link } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { Badge, Heading2, theme } from '@acorns/web-components'
import { getImageAsset } from '@acorns/web-utils'
import styled from 'styled-components'

const logosDesktop = getImageAsset(
  '/invest/custom-portfolio/entry-points/logos',
  'png',
  '@4x',
).url
const logosTablet = getImageAsset(
  '/invest/custom-portfolio/entry-points/logos',
  'png',
  '@2x',
).url
const logosMobile = getImageAsset(
  '/invest/custom-portfolio/entry-points/logos',
  'png',
  '@1x',
).url

export const StyledLink = styled(Link)`
  background-color: ${theme.colors.cloud};
  border-radius: ${theme.borderRadius.large};
  color: ${theme.colors.slate};
  display: grid;
  grid-template-columns: 2fr 1fr;
  position: relative;
  text-decoration: none;
  width: 100%;

  &:visited {
    color: ${theme.colors.slate};
  }
`

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 30px 0 42px 30px;

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    padding: 15px 0 30px 20px;
  }
`

export const StyledBadge = styled(Badge)`
  align-items: center;
  background-color: ${theme.colors.purple};
  color: ${theme.colors.white};
  display: inline-flex;
  gap: 5px;
  justify-content: center;
  width: fit-content;
`

export const StyledText = styled(Heading2)`
  font-size: 30px;
  line-height: 41px;
  white-space: break-spaces;

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    font-size: 23px;
    line-height: 32px;
  }

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    font-size: 16px;
    line-height: 24px;
  }
`

export const StyledImgContainer = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  &:after {
    background-image: url(${logosDesktop});
    background-position: center;
    background-position-x: 50px;
    background-position-y: 15px;
    background-repeat: no-repeat;
    background-size: contain;
    content: '';
    height: 100%;
    width: 100%;

    @media screen and (max-width: ${theme.breakpoints.md}px) {
      background-image: url(${logosTablet});
    }

    @media screen and (max-width: ${theme.breakpoints.sm}px) {
      background-image: url(${logosMobile});
      background-position: center;
      background-position-x: 0;
      background-position-y: 10px;
      background-size: cover;
    }
  }
`

export const StyledCloseButton = styled.button`
  all: unset;
  padding: 10px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 1;

  path {
    &[fill] {
      fill: ${theme.colors.stone};
    }
  }

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    right: 10px;
    top: 10px;
  }
`

export const StyledIcon = styled(AcornsIcon)`
  height: 12px;
  width: 12px;

  path {
    &[fill] {
      fill: ${theme.colors.white};
    }
  }
`
